import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'kiosk-entry',
  standalone: true,
  template: `<p>Loading kiosk…</p>`,
})
export class KioskEntryComponent implements OnInit {
  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    const venueId = this.route.snapshot.paramMap.get('venue_id');
    const tableCode = this.route.snapshot.paramMap.get('table_code');

    localStorage.setItem('kiosk_mode', 'true');
    localStorage.setItem('kiosk_table', tableCode!);
    localStorage.setItem('kiosk_state', 'standard');

    window.location.href = `/${venueId}/menu/food?table=${tableCode}`;
  }
}
